<template>
  <div class="product-form">
    <h2>Create New Product</h2>
    <form @submit.prevent="createProduct">
      <div class="form-group">
        <label for="title">Title</label>
        <input v-model="form.title" type="text" id="title" required/>
      </div>

      <div class="form-group">
        <label for="type">Type</label>
        <input v-model="form.type" type="text" id="type"/>
      </div>

      <div class="form-group">
        <label for="status">Status</label>
        <select v-model="form.status" id="status">
          <option value="">Select Status</option>
          <option v-for="status in productStatuses" :key="status" :value="status">{{ status }}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="subcategory">Subcategory</label>
        <select v-model="form.subcategory" id="subcategory">
          <option value="">Select Subcategory</option>
          <option v-for="subcategory in subcategories" :key="subcategory.id" :value="subcategory.id">
            {{ subcategory.name }}
          </option>
        </select>
      </div>

      <!-- CodeMirror Editor for Components -->
      <div class="form-group">
        <label for="components">Components</label>
        <codemirror-editor-vue3
          v-model:value="form.components"
          :options="editorOptions"
          placeholder="Enter HTML content here..."
          :height="400"
        />
      </div>

      <div class="form-group">
        <label for="tags">Tags</label>
        <input v-model="form.tags" type="text" id="tags" placeholder="Comma-separated tags"/>
      </div>

      <div class="form-group">
        <label for="image">Product Image</label>
        <input type="file" @change="handleFileUpload" id="image"/>
      </div>

      <button type="submit">Create Product</button>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { ref, onMounted } from "vue";
import CodemirrorEditorVue3 from "codemirror-editor-vue3";
import "codemirror/addon/display/placeholder.js";
import "codemirror/mode/javascript/javascript.js"; // Adjust to mode if you want HTML mode
import "codemirror/theme/dracula.css"; // Theme for the editor

export default {
  name: "ProductCreationView",
  components: { CodemirrorEditorVue3 },
  setup() {
    // Form state
    const form = ref({
      title: "",
      type: "",
      status: "",
      subcategory: "",
      components: "",  // This will be bound to the CodeMirror editor
      tags: "",
      image: null,
    });

    // Options for the CodeMirror Editor
    const editorOptions = {
      mode: "text/html", // Language mode for HTML
      theme: "dracula", // Theme
      lineNumbers: true,
      tabSize: 2,
    };

    // Product status options and subcategories
    const productStatuses = ["POPULAR", "NEW", "UPCOMING"];
    const subcategories = ref([]);

    // Load subcategories (assuming you have an API endpoint for this)
    onMounted(() => {
      axios
        .get("/dashboard/subcategories/")
        .then((response) => {
          subcategories.value = response.data;
        })
        .catch((error) => {
          console.error("Error loading subcategories:", error);
        });
    });

    // Handle file upload
    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        form.value.image = file;
      }
    };

    // Create product
    const createProduct = () => {
      const formData = new FormData();
      formData.append("title", form.value.title);
      formData.append("type", form.value.type);
      formData.append("status", form.value.status);
      formData.append("subcategory", form.value.subcategory);
      formData.append("components", form.value.components);
      formData.append("tags", form.value.tags);
      if (form.value.image) {
        formData.append("image", form.value.image);
      }

      axios
        .post("/dashboard/products/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          alert("Product created successfully!");
          form.value = {
            title: "",
            type: "",
            status: "",
            subcategory: "",
            components: "",
            tags: "",
            image: null,
          };
        })
        .catch((error) => {
          console.error("Error creating product:", error);
          alert("There was an error creating the product.");
        });
    };

    return {
      form,
      productStatuses,
      subcategories,
      editorOptions,
      handleFileUpload,
      createProduct,
    };
  },
};
</script>

<style scoped>
.product-form {
  max-width: 500px;
  margin: 0 auto;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  font-weight: bold;
}

input,
select {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  box-sizing: border-box;
}

button {
  display: block;
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
}

button:hover {
  background-color: #45a049;
}
</style>
